// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 그래프(실시간) 화면 */

/* ── 툴바 ── */
.gp-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}

/* 이자포함 체크박스 */
.gp-check-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #444;
  cursor: pointer;
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
}

.gp-check-label input[type="checkbox"] { cursor: pointer; }

/* 영향 패널 힌트 (①④) */
.gp-check-hint {
  font-size: 11px;
  color: #888;
  margin-left: 1px;
}

/* 구분선 */
.gp-sep {
  display: inline-block;
  width: 1px;
  height: 16px;
  background: #ccc;
  margin: 0 2px;
  flex-shrink: 0;
  align-self: center;
}

/* 시세 상태 */
.gp-price-status        { font-size: 11px; flex-shrink: 0; }
.gp-price-status.loading  { color: #888; }
.gp-price-status.realtime { color: #0a8a00; }
.gp-price-status.mixed    { color: #888; }

/* 수동 시세갱신 버튼 */
.gp-refresh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: white;
  font-size: 15px;
  cursor: pointer;
  color: #555;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;
  transition: color 0.2s, border-color 0.2s;
}
.gp-refresh-btn:hover:not(:disabled) { color: #3050c8; border-color: #3050c8; }
.gp-refresh-btn:disabled             { opacity: 0.4; cursor: default; }
.gp-refresh-btn.spinning             { animation: gp-spin 1s linear infinite; }

@keyframes gp-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ── 2×2 그리드 ── */
.gp-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
  padding: 10px;
  box-sizing: border-box;
}

/* ── 개별 패널 ── */
.gp-panel {
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  overflow: hidden;
  min-height: 0;
}

/* 패널 헤더 */
.gp-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 12px;
  background: #f0f2f8;
  border-bottom: 1px solid #e0e4ef;
  flex-shrink: 0;
  gap: 8px;
}

.gp-panel-title {
  font-size: 12px;
  font-weight: 700;
  color: #333;
}

.gp-panel-sub {
  font-size: 11px;
  color: #888;
}

/* 패널 내 토글 버튼 */
.gp-toggle-group { display: flex; gap: 2px; flex-shrink: 0; }

.gp-toggle-btn {
  padding: 2px 8px;
  font-size: 11px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background: white;
  color: #555;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.gp-toggle-btn.active { background: #4a90e2; color: white; border-color: #4a90e2; }
.gp-toggle-btn:hover:not(.active) { background: #f0f4ff; }

/* 패널 차트 영역 */
.gp-panel-body {
  flex: 1 1;
  min-height: 0;
  position: relative;
}

/* 더블클릭 힌트 */
.gp-panel-hint {
  position: absolute;
  bottom: 6px;
  right: 10px;
  font-size: 10px;
  color: #bbb;
  z-index: 1;
  pointer-events: none;
}

/* 데이터 없음 */
.gp-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 12px;
  color: #999;
}

/* recharts 높이 */
.gp-panel-body .recharts-responsive-container {
  width: 100% !important;
  height: 100% !important;
}

/* 패널 헤더 우측 그룹 (현금성포함 + 구분선 + 토글) */
.gp-panel-header-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* 세로 구분선 (헤더 내) */
.gp-vbar {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: #ccc;
  margin: 0 2px;
  flex-shrink: 0;
}

/* 소형 체크박스 레이블 */
.gp-chk-sm { font-size: 11px; }

/* 비활성 (예상수익 모드일 때 현금성포함 비활성) */
.gp-disabled { opacity: 0.4; cursor: default; pointer-events: none; }

/* ── 예상수익 도넛 중앙 텍스트 ── */
.gp-donut-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
  z-index: 1;
}
.gp-donut-center-label {
  font-size: 11px;
  color: #888;
  white-space: nowrap;
}
.gp-donut-center-value {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  margin-top: 2px;
}

/* ── 예상수익액 비율 탭 색상 안내 ── */
.gp-profit-legend {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 11px;
  color: #333;
  text-align: left;
  pointer-events: none;
  z-index: 1;
  max-width: 220px;
  line-height: 1.6;
}
.gp-profit-legend-sep {
  border-top: 1px solid #e8e8e8;
  margin-bottom: 5px;
}
.gp-profit-legend-note {
  font-size: 10px;
  color: #c0c0c0;
  margin-top: 2px;
}

/* ── 공통 툴팁 ── */
.gp-tooltip {
  background: white;
  border: 1px solid #dde2ef;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.gp-tooltip-title { font-weight: 600; margin-bottom: 3px; color: #1a1a2e; }

/* ════════════════════════════════════════════════════════
   포트폴리오 상세 팝업
   ════════════════════════════════════════════════════════ */

.gp-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.gp-popup-box {
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  width: 600px;
  max-width: 96vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gp-popup-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1a2e;
  background: #f0f2f8;
  border-bottom: 1px solid #dde2ef;
  flex-shrink: 0;
}

.gp-popup-close {
  background: none;
  border: none;
  font-size: 16px;
  color: #888;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
}
.gp-popup-close:hover { color: #333; }

.gp-popup-body {
  overflow-y: auto;
  flex: 1 1;
  padding: 0;
}

/* 팝업 테이블 */
.gp-popup-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.gp-popup-table thead tr {
  background: #f5f7ff;
  position: sticky;
  top: 0;
  z-index: 1;
}

.gp-popup-table th {
  padding: 7px 10px;
  font-weight: 700;
  color: #444;
  border-bottom: 2px solid #dde2ef;
  white-space: nowrap;
  text-align: left;
}

.gp-popup-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #f0f2f8;
  white-space: nowrap;
}

.gp-popup-table tbody tr:hover { background: #f8f9ff; }

.gp-popup-table .gp-col-r    { text-align: right; }
.gp-popup-table .gp-col-ticker { color: #888; font-size: 11px; }
`, "",{"version":3,"sources":["webpack://./src/pages/status/GraphPage.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,yCAAyC,eAAe,EAAE;;AAE1D,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,UAAU;AACV,0BAA0B,eAAe,EAAE,cAAc,EAAE;AAC3D,4BAA4B,WAAW,EAAE;AACzC,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,WAAW,EAAE;;AAEzC,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;AACA,uCAAuC,cAAc,EAAE,qBAAqB,EAAE;AAC9E,uCAAuC,YAAY,EAAE,eAAe,EAAE;AACtE,uCAAuC,qCAAqC,EAAE;;AAE9E;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAS;EACT,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf,mBAAmB,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAE5D;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yCAAyC;AAC3C;AACA,wBAAwB,mBAAmB,EAAE,YAAY,EAAE,qBAAqB,EAAE;AAClF,oCAAoC,mBAAmB,EAAE;;AAEzD,aAAa;AACb;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA,gBAAgB;AAChB,aAAa,eAAe,EAAE;;AAE9B,+BAA+B;AAC/B,eAAe,YAAY,EAAE,eAAe,EAAE,oBAAoB,EAAE;;AAEpE,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;AACA,oBAAoB,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE1E;;6DAE6D;;AAE7D;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA,wBAAwB,WAAW,EAAE;;AAErC;EACE,gBAAgB;EAChB,SAAO;EACP,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iCAAiC,mBAAmB,EAAE;;AAEtD,+BAA+B,iBAAiB,EAAE;AAClD,iCAAiC,WAAW,EAAE,eAAe,EAAE","sourcesContent":["/* 그래프(실시간) 화면 */\n\n/* ── 툴바 ── */\n.gp-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n/* 이자포함 체크박스 */\n.gp-check-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #444;\n  cursor: pointer;\n  flex-shrink: 0;\n  user-select: none;\n}\n\n.gp-check-label input[type=\"checkbox\"] { cursor: pointer; }\n\n/* 영향 패널 힌트 (①④) */\n.gp-check-hint {\n  font-size: 11px;\n  color: #888;\n  margin-left: 1px;\n}\n\n/* 구분선 */\n.gp-sep {\n  display: inline-block;\n  width: 1px;\n  height: 16px;\n  background: #ccc;\n  margin: 0 2px;\n  flex-shrink: 0;\n  align-self: center;\n}\n\n/* 시세 상태 */\n.gp-price-status        { font-size: 11px; flex-shrink: 0; }\n.gp-price-status.loading  { color: #888; }\n.gp-price-status.realtime { color: #0a8a00; }\n.gp-price-status.mixed    { color: #888; }\n\n/* 수동 시세갱신 버튼 */\n.gp-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  background: white;\n  font-size: 15px;\n  cursor: pointer;\n  color: #555;\n  line-height: 1;\n  padding: 0;\n  flex-shrink: 0;\n  transition: color 0.2s, border-color 0.2s;\n}\n.gp-refresh-btn:hover:not(:disabled) { color: #3050c8; border-color: #3050c8; }\n.gp-refresh-btn:disabled             { opacity: 0.4; cursor: default; }\n.gp-refresh-btn.spinning             { animation: gp-spin 1s linear infinite; }\n\n@keyframes gp-spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* ── 2×2 그리드 ── */\n.gp-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n/* ── 개별 패널 ── */\n.gp-panel {\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* 패널 헤더 */\n.gp-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 12px;\n  background: #f0f2f8;\n  border-bottom: 1px solid #e0e4ef;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.gp-panel-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #333;\n}\n\n.gp-panel-sub {\n  font-size: 11px;\n  color: #888;\n}\n\n/* 패널 내 토글 버튼 */\n.gp-toggle-group { display: flex; gap: 2px; flex-shrink: 0; }\n\n.gp-toggle-btn {\n  padding: 2px 8px;\n  font-size: 11px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  background: white;\n  color: #555;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.gp-toggle-btn.active { background: #4a90e2; color: white; border-color: #4a90e2; }\n.gp-toggle-btn:hover:not(.active) { background: #f0f4ff; }\n\n/* 패널 차트 영역 */\n.gp-panel-body {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n/* 더블클릭 힌트 */\n.gp-panel-hint {\n  position: absolute;\n  bottom: 6px;\n  right: 10px;\n  font-size: 10px;\n  color: #bbb;\n  z-index: 1;\n  pointer-events: none;\n}\n\n/* 데이터 없음 */\n.gp-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 12px;\n  color: #999;\n}\n\n/* recharts 높이 */\n.gp-panel-body .recharts-responsive-container {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* 패널 헤더 우측 그룹 (현금성포함 + 구분선 + 토글) */\n.gp-panel-header-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n/* 세로 구분선 (헤더 내) */\n.gp-vbar {\n  display: inline-block;\n  width: 1px;\n  height: 14px;\n  background: #ccc;\n  margin: 0 2px;\n  flex-shrink: 0;\n}\n\n/* 소형 체크박스 레이블 */\n.gp-chk-sm { font-size: 11px; }\n\n/* 비활성 (예상수익 모드일 때 현금성포함 비활성) */\n.gp-disabled { opacity: 0.4; cursor: default; pointer-events: none; }\n\n/* ── 예상수익 도넛 중앙 텍스트 ── */\n.gp-donut-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n  z-index: 1;\n}\n.gp-donut-center-label {\n  font-size: 11px;\n  color: #888;\n  white-space: nowrap;\n}\n.gp-donut-center-value {\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n  margin-top: 2px;\n}\n\n/* ── 예상수익액 비율 탭 색상 안내 ── */\n.gp-profit-legend {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  font-size: 11px;\n  color: #333;\n  text-align: left;\n  pointer-events: none;\n  z-index: 1;\n  max-width: 220px;\n  line-height: 1.6;\n}\n.gp-profit-legend-sep {\n  border-top: 1px solid #e8e8e8;\n  margin-bottom: 5px;\n}\n.gp-profit-legend-note {\n  font-size: 10px;\n  color: #c0c0c0;\n  margin-top: 2px;\n}\n\n/* ── 공통 툴팁 ── */\n.gp-tooltip {\n  background: white;\n  border: 1px solid #dde2ef;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n.gp-tooltip-title { font-weight: 600; margin-bottom: 3px; color: #1a1a2e; }\n\n/* ════════════════════════════════════════════════════════\n   포트폴리오 상세 팝업\n   ════════════════════════════════════════════════════════ */\n\n.gp-popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.gp-popup-box {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);\n  width: 600px;\n  max-width: 96vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.gp-popup-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a1a2e;\n  background: #f0f2f8;\n  border-bottom: 1px solid #dde2ef;\n  flex-shrink: 0;\n}\n\n.gp-popup-close {\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: #888;\n  cursor: pointer;\n  padding: 0 2px;\n  line-height: 1;\n}\n.gp-popup-close:hover { color: #333; }\n\n.gp-popup-body {\n  overflow-y: auto;\n  flex: 1;\n  padding: 0;\n}\n\n/* 팝업 테이블 */\n.gp-popup-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.gp-popup-table thead tr {\n  background: #f5f7ff;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.gp-popup-table th {\n  padding: 7px 10px;\n  font-weight: 700;\n  color: #444;\n  border-bottom: 2px solid #dde2ef;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.gp-popup-table td {\n  padding: 6px 10px;\n  border-bottom: 1px solid #f0f2f8;\n  white-space: nowrap;\n}\n\n.gp-popup-table tbody tr:hover { background: #f8f9ff; }\n\n.gp-popup-table .gp-col-r    { text-align: right; }\n.gp-popup-table .gp-col-ticker { color: #888; font-size: 11px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
